import script from "./registration.vue?vue&type=script&setup=true&lang=js"
export * from "./registration.vue?vue&type=script&setup=true&lang=js"

import "./registration.vue?vue&type=style&index=0&id=78f7ebe2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f7ebe2"]])

export default __exports__